import { format } from 'date-fns';

export const formatDate = (date: Date | string, formatConstant: string) => {
  if (typeof date === 'string') {
    return format(new Date(date), formatConstant);
  }
  return format(date, formatConstant);
};

export const API_DAY_FORMAT = 'yyyy-MM-dd';
export const toApiDayFormat = (date: Date | string) =>
  formatDate(date, API_DAY_FORMAT);

export const INTERFACE_DAY_FORMAT = 'MM/dd/yyyy';
export const toInterfaceDayFormat = (date: Date | string) =>
  formatDate(date, INTERFACE_DAY_FORMAT);

export const INTERFACE_HOUR = 'hh:mm aaa';
export const toInterfaceHour = (date: Date | string) =>
  formatDate(date, INTERFACE_HOUR);

export const getTodayDay = () => format(new Date(), 'EEEE').toLocaleLowerCase();
